/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TCanPostAsOwnerModel,
  ICanPostAsOwnerRequest,
  IMappers,
  ICanPostAsOwnerResponse,
  ICanPostAsOwnerResponseError,
  TCanPostAsOwnerResponse,
} from './types';

const defaultConfig: TCanPostAsOwnerModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'commercial-owner',
  pathApi: '/v1/can-post-as-owner/',
  hostType: 'api',
} as TCanPostAsOwnerModel;

function createCanPostAsOwnerModel(parameters: ICanPostAsOwnerRequest): TCanPostAsOwnerModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ICanPostAsOwnerOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: ICanPostAsOwnerRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchCanPostAsOwner<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: ICanPostAsOwnerOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TCanPostAsOwnerResponse> {
  const { response, statusCode } = await httpApi.fetch(createCanPostAsOwnerModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ICanPostAsOwnerResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as ICanPostAsOwnerResponseError);
    }
  }

  return { response, statusCode } as TCanPostAsOwnerResponse;
}

export { defaultConfig, createCanPostAsOwnerModel, fetchCanPostAsOwner };
